import organization from './organization'

export default {
  name: 'BaseInfoOrganization',
  path: 'organization',
  meta: {
    label: 'organization',
    auth: 'organization'
  },
  component: {
    name: 'Organization',
    render(c) {
      return c('router-view')
    }
  },
  children: [organization]
}
